module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.4144/img/solutions-provider-icon.svg"